module.exports = __webpack_public_path__ + "static/img/weixin.7985be64.png";